(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cupones-ofertas"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cupones-nav__pill').forEach(function(pill) {
    pill.addEventListener('click', function() {
      document.querySelectorAll('.cupones-nav__pill').forEach(function(p) {
        p.classList.remove('is-active');
      });
      pill.classList.add('is-active');
    });
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var id = entry.target.getAttribute('id');
        document.querySelectorAll('.cupones-nav__pill').forEach(function(p) {
          p.classList.remove('is-active');
          if (p.getAttribute('href') === '#' + id) {
            p.classList.add('is-active');
          }
        });
      }
    });
  }, { rootMargin: '-20% 0px -60% 0px' });

  document.querySelectorAll('.cupones-grupo').forEach(function(grupo) {
    observer.observe(grupo);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-lg"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-lg"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      connectedCallback() {
        // Close other 3rd level menus when opening a new one (desktop only)
        this.addEventListener('toggle', (e) => {
          if (!e.target.matches('nav-menu > details')) return;
          
          if (e.target.open && window.matchMedia(theme.mediaQueries.md).matches) {
            // Find the parent modal container
            const parentModal = this.closest('.main-nav__child');
            if (!parentModal) return;
            
            // Close all other 3rd level menus in the same modal
            const allNavMenus = parentModal.querySelectorAll('nav-menu > details');
            allNavMenus.forEach(details => {
              if (details !== e.target && details.open) {
                details.open = false;
              }
            });
          }
        }, true); // Use capture phase to catch the event
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
